import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import MenuBar from '../../components/menuBar/menuBar';
import PageFooter from '../../components/pageFooter/pageFooter';
import HeroSection from '../../components/landingPageComponents/HeroSection/HeroSection';
import StatsBar from '../../components/landingPageComponents/StatsBar/StatsBar';
import AboutSection from '../../components/landingPageComponents/AboutSection/AboutSection';
import ProblemSection from '../../components/landingPageComponents/ProblemSection/ProblemSection';
import FeaturesSection from '../../components/landingPageComponents/FeaturesSection/FeaturesSection';
import FounderLetter from '../../components/landingPageComponents/FounderLetter/FounderLetter';
import PricingSection from '../../components/landingPageComponents/PricingSection/PricingSection';
import FAQSection from '../../components/landingPageComponents/FAQSection/FAQSection';

const LandingPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Prepal - AI-Powered SAT Prep</title>
                <meta name="description" content="Welcome to Prepal - an AI-driven test prep, personalized to match your goals. Get your dream score faster with smart, personalized practice." />
                <meta name="keywords" content="Prepal, SAT prep, AI test preparation, personalized learning, SAT practice, test prep platform" />
                <meta name="author" content="Prepal Team" />
            </Helmet>

            <MenuBar />
            <HeroSection />
            <StatsBar />
            <AboutSection />
            <ProblemSection />
            <FeaturesSection />
            <FounderLetter />
            <PricingSection />
            <FAQSection />
            <PageFooter />
        </>
    );
};

export default LandingPage;

